import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';
import { getCookie } from '@zola-helpers/client/dist/es/util/storage';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';

// Experiment Keys:
// 👇 example key (currently deprecated)
// export const EXAMPLE_FLAG = 'example-flag;
// keep for cookie value?
export const AUTH_FORM_V2 = 'auth-form-v2'; // INSPO-4327
export const SHOP_HOLIDAY_2021 = 'shop-holidays2021'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-922
export const SUBNAV_ABC_TEST = 'marketplace_navigation_changes'; // https://newamsterdamlabs.atlassian.net/browse/INSPO-6462
export const YOUR_WEDDING_NAV = 'your-wedding-nav'; // https://newamsterdamlabs.atlassian.net/browse/CE-2116 - roll out to 100% of existing users
export const YOUR_WEDDING_NAV_NEW_USERS = 'your-wedding-nav-new-users'; // https://newamsterdamlabs.atlassian.net/browse/CE-2116 - roll out to 50% of new users after experiment start

const FALLBACK_VARIATIONS = {
  // 👇 example variation (currently deprecated)
  // [EXAMPLE_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [AUTH_FORM_V2]: experimentFlagsHelper.createExperimentFlags(),
  [SHOP_HOLIDAY_2021]: experimentFlagsHelper.createExperimentFlags(),
  [SUBNAV_ABC_TEST]: experimentFlagsHelper.createExperimentFlags(),
  [YOUR_WEDDING_NAV]: experimentFlagsHelper.createExperimentFlags(),
  [YOUR_WEDDING_NAV_NEW_USERS]: experimentFlagsHelper.createExperimentFlags(),
};

const {
  getFlag,
  getExperimentVariation,
  isUnderTest,
  isInExperiment,
} = experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);

export const isInSubnavTestB = (userContext: UserContext | null): boolean => {
  return (
    getCookie('automatedTest') === '' &&
    getExperimentVariation(SUBNAV_ABC_TEST, userContext) === 'TEST-1'
  );
};

export const isInSubnavTestC = (userContext: UserContext | null): boolean => {
  return (
    getCookie('automatedTest') === '' &&
    getExperimentVariation(SUBNAV_ABC_TEST, userContext) === 'TEST-2'
  );
};

export const isInSubnavTestA = (userContext: UserContext | null): boolean => {
  return (
    getCookie('automatedTest') === 'true' ||
    (!isInSubnavTestB(userContext) && !isInSubnavTestC(userContext))
  );
};

export const isInSubnavTest = (
  userContext: UserContext | null,
  isMarketplacePage: boolean
): boolean => {
  return isMarketplacePage && (isInSubnavTestB(userContext) || isInSubnavTestC(userContext));
};

export const isYourWeddingNavTest = (userContext: UserContext | undefined): boolean => {
  let isTest;
  const isNewUserInYourWeddingNavTest = isInExperiment(
    YOUR_WEDDING_NAV_NEW_USERS,
    userContext,
    false
  ); // true for all new users since experiment start
  if (isNewUserInYourWeddingNavTest) {
    isTest = isUnderTest(YOUR_WEDDING_NAV_NEW_USERS, userContext); // true for 50% of new users
  } else {
    isTest = getFlag(YOUR_WEDDING_NAV, userContext); // true for 100% of existing users
  }
  return isTest;
};

export default {
  getExperimentVariation,
  isUnderTest,
  getFlag,
  isInExperiment,
};
